import { useQuery } from "react-query";
import axios from "infra/http";
import { AreaComumTaxasForm } from "../typings";

function useTaxasAreaComum(tenantId: string | null, id: string) {
  return useQuery(
    `/v1/tenants/${tenantId}/area-comum/${id}/taxas`,
    async () => {
      const { data } = await axios.get<AreaComumTaxasForm>(
        `/v1/tenants/${tenantId}/area-comum/${id}/taxas`
      );

      return data;
    },
    {
      enabled: !!id && !!tenantId,
    }
  );
}

export default useTaxasAreaComum;
